import { render, staticRenderFns } from "./doctorRegister.vue?vue&type=template&id=2b805cb6&"
import script from "./doctorRegister.vue?vue&type=script&lang=js&"
export * from "./doctorRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports